"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tasks_at = void 0;
const inspect_1 = require("../../utils/inspect");
function tasks_at(chart, index) {
    const task_map = chart[index];
    if (task_map === undefined) {
        throw new Error("task_map is empty\n" +
            `index: ${index}\n` +
            `chart: ${(0, inspect_1.inspect)(chart)}\n`);
    }
    return task_map.values();
}
exports.tasks_at = tasks_at;
//# sourceMappingURL=task-chart-tasks-at.js.map